// Lib
import { classicFormat } from '@/hooks/format/useFormatNumber';

// Types
import { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const gainedLostFollowersConfig: ChartType<typeof HalfBarLineChart> = {
    title: 'chart.instagram.gained_lost_followers',
    tooltip: 'chart.instagram.gained_lost_followers_tooltip',
    id: 'gained_lost_followers_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        gained: 'chart.instagram.gained_lost_followers_gained',
        lost: 'chart.instagram.gained_lost_followers_lost',
        total: 'chart.instagram.gained_lost_followers_total',
        posts: 'chart.instagram.gained_lost_followers_posts'
    },
    social: INSTAGRAM,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'chart.post_engagements.followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        gained: 'green',
        lost: 'gray',
        posts: 'blue'
    },
    legendTypes: {
        gained: 'square',
        lost: 'square',
        posts: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart
};
